import Vue from 'vue'
import VueRouter from 'vue-router'

// /////// //
// drawers //
// /////// //
import WhiteboardDrawer from '@/views/whiteboard/drawer/WhiteboardDrawer'
import AdminDrawer from '@/views/adminDashboard/drawer/AdminDrawer'
// import UserDrawer from '@/views/userDashboard/drawer/UserDrawer'

// ///// //
// views //
// ///// //
import Login from '@/views/login/Index'
import AuthRedirect from '@/views/login/AuthRedirect'

import Whiteboard from '@/views/whiteboard/Index'

// dashboards
import AdminDashboard from '@/views/adminDashboard/Index'
import Organizations from '@/views/adminDashboard/pages/organizations/Organizations'
import Users from '@/views/adminDashboard/pages/users/Users'

// import UserDashboard from '@/views/userDashboard/Index'

// import ChallengeIndex from '@/views/challenges/Index'
import ActiveChallengeList from '@/views/challenges/ActiveChallengeList'
import ChallengePage from '@/views/challenges/challengePage/ChallengePage'

import ArchivedChallengeList from '@/views/challenges/ArchivedChallengeList'

// //// //
// misc //
// //// //
import UserProfile from '@/views/userProfile/UserProfile'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/activate',
      component: Login
    },
    {
      path: '/forgotPassword',
      component: Login
    },
    {
      path: '/reset',
      component: Login
    },
    {
      path: '/auth',
      component: AuthRedirect
    },
    // //////////// //
    //  whiteboard  //
    // //////////// //
    {
      path: '/user-profile',
      component: UserProfile
    },
    {
      path: '/whiteboard/:id',
      name: 'whiteboard',
      components: {
        default: Whiteboard,
        drawer: WhiteboardDrawer
      }
    },
    // ///////////////// //
    //  admin dashboard  //
    // ///////////////// //
    {
      path: '/admin-dashboard',
      name: 'admin-dashboard',
      components: {
        default: AdminDashboard,
        drawer: AdminDrawer
      },
      children: [
        {
          path: '',
          redirect: 'active-challenges'
        },
        {
          path: 'organizations',
          component: Organizations
        },
        {
          path: 'users',
          component: Users
        },
        {
          path: 'active-challenges',
          component: ActiveChallengeList,
          props: { global: false }
        },
        {
          path: 'archived-challenges',
          component: ArchivedChallengeList,
          props: { global: false }
        },
        {
          path: 'global-active-challenges',
          component: ActiveChallengeList,
          props: { global: true }
        },
        {
          path: 'global-archived-challenges',
          component: ArchivedChallengeList,
          props: { global: true }
        },
        {
          path: 'challenge',
          component: ChallengePage,
          children: [
            {
              path: '',
              redirect: 'new'
            },
            {
              path: 'new',
              name: 'new-challenge'
            },
            {
              path: ':id',
              name: 'challenge-page',
              component: ChallengePage
            }
          ]
        }
      ]
    }
    // /////////////// //
    //  user dashboard //
    // /////////////// //
    // {
    //   path: '/user-dashboard',
    //   components: {
    //     default: UserDashboard,
    //     drawer: UserDrawer
    //   },
    //   children: [
    //     {
    //       path: '',
    //       redirect: 'challenges'
    //     },
    //     // challenges
    //     {
    //       path: 'challenges',
    //       component: ChallengeIndex,
    //       children: [
    //         {
    //           path: '',
    //           component: ActiveChallengeList
    //         },
    //         {
    //           path: ':id',
    //           component: ChallengePage
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
})

export default router
